import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-arrow-right',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()"
         [attr.height]="size()" viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-miterlimit="16" stroke-width="1.5" d="M9.00005 6 15 12l-6 6" />
    </svg>
  `
})
export class IconArrowRightComponent {
  size: InputSignal<number> = input<number>(24);
}
